module.exports = __webpack_public_path__ + "static/media/MHSBKP.1d936b5b.png";